// Age Transitions is a reminder only — a child's Age Group/category is updated directly in
// Edit Child. Rows are not clickable and do not open any assignment workflow.
const formatMMDDYY = (iso) => {
  const [y, m, d] = iso.split("-");
  return `${m}/${d}/${y.slice(2)}`;
};

export const TransitionsPanel = ({ transitions }) => {
  return (
    <div className="bg-white rounded-xl border border-slate-200 p-4 h-full" data-testid="transitions-panel">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-1">
        <h2 className="text-sm font-semibold text-slate-600">Age Transitions</h2>
        <span className="text-xs text-slate-400">(next 30 days)</span>
      </div>

      {transitions.length === 0 && <p className="text-sm text-slate-300">No transitions due in the next 30 days.</p>}

      <div className="space-y-2">
        {transitions.map((t) => {
          const overdue = t.daysRemaining < 0;
          return (
            <div
              key={t.childId}
              data-testid={`transition-row-${t.childId}`}
              className="w-full rounded-lg border border-[#D8A657]/40 bg-[#D8A657]/[0.06] px-3 py-2"
            >
              <div className="text-sm text-slate-600 truncate">{t.childName}</div>
              <div className="flex items-center justify-between mt-0.5">
                <span className="text-xs text-slate-400 truncate">{t.currentRoomName}</span>
                <span className={`text-xs font-medium whitespace-nowrap ${overdue ? "text-[#B85C5C]" : "text-[#B8873C]"}`}>
                  {overdue ? `${Math.abs(t.daysRemaining)}d overdue` : t.daysRemaining === 0 ? "Due today" : `${t.daysRemaining}d left`}
                </span>
              </div>
              <div className="text-xs text-slate-400 mt-1" data-testid={`transition-reminder-${t.childId}`}>
                Reminder: Update Age Group in Edit Child.<br />Classroom Move-Up Date: {formatMMDDYY(t.ageOutDate)}.
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
